import { postApiErrorLogClientSideError } from "./postApiErrorLogClientSideError";

export function errorController() {
  return { postApiErrorLogClientSideError };
}
